
import { granjaApi } from "../../api";
import Swal from "sweetalert2";





export const subirImagenXModelo = async(imagen) => {
    try {
        const formData = new FormData();
        formData.append('images', imagen.img);  
        Object.entries(imagen).forEach(([key, value]) => {
            formData.append(key, value.toString());
        });

        const { data } = await granjaApi.post(`/uploads/subirimg`, formData);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}






